import React from 'react';
import { Alert, Box, CircularProgress } from '@mui/material';
import { Navigate, Route, Routes } from 'react-router-dom';
import { appDocumentTitle } from '../../appMeta';
import { useAuth } from '../../auth/AuthContext';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { PageShell } from '../../layout/PageShell';
import { useNavigationMenuQuery } from '../../query/hooks';
import { LaboratoryResultDetailRoute } from './LaboratoryResultDetailRoute';
import { LaboratoryResultListTabScreen } from './TabScreens/List';

export function LaboratoryResultsPage() {
  const { jwt } = useAuth();
  const menuQ = useNavigationMenuQuery(jwt);
  const canView = menuQ.data?.access_codes?.includes('can_view_laboratory_result') ?? false;

  useDocumentTitle(appDocumentTitle('Hasil uji lab'));

  if (menuQ.isPending) {
    return (
      <Box display="flex" justifyContent="center" py={4}>
        <CircularProgress size={32} />
      </Box>
    );
  }

  if (menuQ.isError) {
    return (
      <Alert severity="error">
        {menuQ.error instanceof Error ? menuQ.error.message : 'Gagal memuat menu permission.'}
      </Alert>
    );
  }

  if (!canView) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <Routes>
      <Route
        index
        element={
          <PageShell
            title="Hasil uji lab"
            subtitle="Parameter hasil uji dari work order yang RPS-nya sudah Approved. Expand baris untuk isian petugas sampling."
          >
            <LaboratoryResultListTabScreen />
          </PageShell>
        }
      />
      <Route path="work-order/:workOrderDocumentId" element={<LaboratoryResultDetailRoute />} />
    </Routes>
  );
}
